<template>
  <article class="trainers">


    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg6 class="head_contain">
            <p class="table_card__head--title">
             Eventos
            </p>
          </v-flex>
          <v-flex xs12 lg6 class="filter_options">
            <v-flex class="right mr-20">
              <button
                class="faccess_button"
                @click="$router.push({name: 'new_event'})"
              >
                Crear nuevo evento
              </button>
            </v-flex>
            <div
              class="buttom_reload"
              @click="findEventsByType()"
            >
              <img src="@/assets/img/icons/refresh-icon.svg">
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__body">
          <section class="trainers__container">
            <section
              class="data_card_special"
              v-for="event in events"
              :key="event.id"
            >
              <!-- style="cursor:pointer"
                @click="$router.push({name: 'sublocations', params: {id: location.id}})" -->
              <iframe
                  v-if="event.attributes.news_type == 'Video' || event.attributes.url_type == 'video'"
                  class="data_card_special__image"
                  :src="'https://www.youtube.com/embed/' + event.attributes.url.replace('https://youtu.be/','')+'?rel=0'"
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  style="padding-top: 0; height: 200px; max-height: 200px;"
                ></iframe>
              <div
              v-else
              class="data_card_special__image"
              :style="{backgroundImage: 'url('+ getImageServer() + event.attributes.url +')'}"></div>
              <div class="data_card_special__buttons">
                <div class="data_card_special__buttons--container">
                  <div
                    class="data_card_special__buttons--edit"
                    @click="$router.push({name: 'edit_event', params: {event_id: event.id}})">
                    <v-icon>create</v-icon>
                  </div>
                </div>
              </div>
              <div class="data_card_special__info">
                <p class="data_card_special__info--title">
                  {{event.attributes.name}}
                </p>
                <div class="data_card_special__info--container">
                  <span class="data_card_special__info--label">Fecha de Evento</span>
                  <p class="data_card_special__info--text_date full_text">
                    {{ shortDateEvent(event.attributes.event_date) }}
                  </p>
                </div>
                <div class="data_card_special__info--container">
                  <span class="data_card_special__info--label">Descripción</span>
                  <p class="data_card_special__info--text full_text" v-html="event.attributes.description">
                    <!-- {{}} -->
                  </p>
                </div>
              </div>
          </section>
        </section>
      </div>
    </div>

  </article>
</template>

<script>
export default {
  props: ['type'],
  data(){
    return{
      events:[],
    }
  },
  methods:{
    shortDate(date){
      let new_date =  date.substring(0,date.indexOf('T'))
      return new_date
    },
    shortDateEvent(date){
      return date.substring(6)+'-'+date.substring(3,5)+'-'+date.substring(0,2)
    },
    findEventsByType(){
      console.log(this.type)
      try {
        this.$http.get('app/events/'+this.type+'/show_by_state',{
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()},
        })
        .then(function(response){
          this.events = response.body.data
          console.log('################## this.events #################### ', this.events)
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    }

  },
  mounted(){
    this.findEventsByType()
  },
  watch: {
    $route(to, from) {
      this.findEventsByType();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/events/Index.vue